import { postApiNoAuth } from "../genericServices";

export async function postNewsletter(email) {
    return await postApiNoAuth('newsletter', { email: email })
}